<div class="share-feedback-messages box_default box_white" [ngClass]="{'no-messages' : messagesList!=null && messagesList.length==0}">
    <header>
        <h3>APPROVAL FEEDBACK</h3>
    </header>
    <!-- TODO pending to set post urls correctly -->
    <div class="feedback-messages-form" *ngIf="addMessage">
        <core-message-add
            [context]="context"
            [user]="user"
            [action]="messageAddUrl"
            (onSaved)="saveMessage($event)">
        </core-message-add>
    </div>
    <div class="loader" [hidden]="status != STATUS_LOADING">
        <div class="dimmed"  >
            <div class="dimmed_avatar"></div>
            <div class="dimmed_info">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <div class="dimmed">
            <div class="dimmed_avatar"></div>
            <div class="dimmed_info">
                <div class="dimmed_title"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <!--  <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
    </div>
    
    <!-- messages list -->
    <article *ngIf="messagesList != null" class="messages-section-main">
        <plugin-share-feedback-core-version-approval-message-list
            *ngIf="messagesList.length > 0"
            [messages]="messagesList"
            [user]="user"
            [notesActionText]="notesActionText"
            [notesActionStyle]="notesActionStyle"
            [canCreateNotes]="canCreateNotes"
            [canDelete]="canDelete"
            [prefixUrl]="prefixNotesUrl"
            (onDelete)="messageDeleted($event)"
        ></plugin-share-feedback-core-version-approval-message-list>
        <article *ngIf="messagesList.length==0" class="message-not-content">
            <core-helpers-box-alert-message-icon
            [text]="'There are currently no messages.'"
            [icon]="'no_messages'"
            ></core-helpers-box-alert-message-icon>
        </article>
    </article>
</div>


